module.exports = function() {
  return new Worker(__webpack_public_path__ + "4241470ed79cb5e6417a.worker.js");
};